import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why you should learn serverless cloud functions",
  "description": "Times are changing, the future of web development is here.Story time! 20 years of history in a 2min read, it's gonna be great 🤘",
  "published": "2020-09-25T00:00:00.000Z",
  "hero": "./img/screenshot-1601052620372.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Times are changing, the future of web development is here.`}</p>
    <p>{`Story time! 20 years of history in a 2min read, it's gonna be great 🤘`}</p>
    <p>{`Cue 2001. Young Swiz here just convinced his mom to install ADSL, an early version of broadband. 256kbps`}</p>
    <p><em parentName="p">{`"You don't want dial-up mom, I'd just rack up the phone bill so much you'd think the time I spent `}{`\\`}{`\\`}{`$300 calling porn hotlines a pleasant joke"`}</em></p>
    <p>{`Hey we didn't have the internet in middle school. Sketchy phone numbers in grandpa's boobie magazines were all you could get.`}</p>
    <h2 {...{
      "id": "putting-up-a-site-in-the-early-days"
    }}>{`Putting up a site in the early days`}</h2>
    <p>{`With ADSL going straight to my bedroom it was time to get into web development. How?`}</p>
    <p>{`Oh that's easy. You just create an HTML file and you have a website. CSS wasn't popular yet, JavaScript was a joke.`}</p>
    <p>{`Then what?`}</p>
    <p>{`Oh that's easy, you dummy.`}</p>
    <p>{`You run Apache on your Linux machine, put `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` in the right directory, open port 80 in your iptables, set your ADSL modem to pass-through mode, turn your computer into the network router, beg your internet provider for a static IP (my mom still uses it, good old 193.77.212.100), and you have a website. Yay!`}</p>
    <p>{`Wait no, first you gotta send money in an envelope to a domain registrar to get a domain. Online payments are still the future. 😅`}</p>
    <p>{`Oh you want your site to be dynamic? Use the LAMP stack? (linux, apache, mysql, php)`}</p>
    <p>{`That's easy!`}</p>
    <p>{`Install PHP on your computer, configure Apache to reverse proxy port 80 to your running PHP server, create config rules to run the PHP script on every request, and voila. You've got a computer open to exploit from every script kiddie on the internet with 5min to spare!`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media0.giphy.com/media/2xO491sY6f0cM/giphy-loop.mp4?cid=7cf28b0f31a0ye2pd6v432q1ficyx6vogztq22ns91hpcme1&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "times-improve-with-virtual-hosting"
    }}>{`Times improve with virtual hosting`}</h2>
    <p>{`Web development got a massive upgrade when collocation and virtual hosting (VPS) became popular in the mid 2000's.`}</p>
    <p>{`As operating systems and hardware learned how to run multiple servers on 1 machine, isolated from each other, people started opening up. You could pay someone to run your website. 😍`}</p>
    <p>{`If your site was big, you'd use collocation. Grab a machine, set it up, carry it down to the neighborhood data center and hook up. At least it isn't in your bedroom.`}</p>
    <p>{`For a smaller site, you could pay a small fee for SSH access.`}</p>
    <p>{`A bloke dealt with servers, you got a virtual machine. No more network config, just the Apache, PHP, MySQL, and other software concerns. Much easier!`}</p>
    <h2 {...{
      "id": "the-cloud"
    }}>{`The Cloud`}</h2>
    <p>{`Then the 2010's hit. Suddenly we had cloud and platform-as-a-service (PaaS) providers.`}</p>
    <p>{`This was amazing.`}</p>
    <p>{`For the first time, you didn't need to worry about servers at all. Run a command, get a server. No SSH, no process daemons, no command line muckery.`}</p>
    <p>{`You wrote your website in a full-stack framework like Rails, Django, or Express, clicked a button, and your app is live.`}</p>
    <p>{`And then your credit card melted.`}</p>
    <p>{`You shouldn't run machine learning algorithms on Google AppEngine in 2010. Ask me how I know 😅`}</p>
    <p>{`Cloud and PaaS were new back then. Expensive as heck and kinda difficult to use. You got the worst of both worlds.`}</p>
    <p>{`No control over your execution environment, but needed to know your execution environment in great detail to make your app smooth.`}</p>
    <p>{`Plus a lot of the config was on you.`}</p>
    <p>{`No automatic CDNs, no automatic domain configs, little automatic routing, lots of arcane incantations to get it all juuuust right. Want to replicate the config on a new environment or set up per-branch deploys? lol, tough luck`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media3.giphy.com/media/xT5LMTsSK0xZPVlfPy/giphy-loop.mp4?cid=7cf28b0fxos27guwoqauoxik3rs8eojwoioaqsaasy4t4vyp&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "2020-is-galaxy-brain"
    }}>{`2020 is galaxy brain`}</h2>
    <p>{`Here's what putting up a new server looks like in 2020:`}</p>
    <p><img parentName="p" {...{
        "src": "/412eabb35fe281cb452e125f38b49f56/Vercel-cloud-function-demo884651.gif",
        "alt": "Vercel cloud function demo"
      }}></img></p>
    <p>{`That one command gives you:`}</p>
    <ul>
      <li parentName="ul">{`a new custom domain`}</li>
      <li parentName="ul">{`https support`}</li>
      <li parentName="ul">{`a configured server running your code`}</li>
      <li parentName="ul">{`on-demand pricing`}</li>
      <li parentName="ul">{`CDN setup for fast performance`}</li>
      <li parentName="ul">{`static file hosting`}</li>
      <li parentName="ul">{`cloud function for backend code`}</li>
      <li parentName="ul">{`distributed logs`}</li>
      <li parentName="ul">{`guaranteed uptime`}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/0a803b79fe27b0dc90bb13572531cbda/giphygif892gg1.gif",
        "alt": null
      }}></img></p>
    <p>{`I've been watching and studying this space for 2 years now and it's ridiculous how good it's become. You don't want to miss this.`}</p>
    <h2 {...{
      "id": "join-serverless-workshop-today"
    }}>{`Join Serverless Workshop today`}</h2>
    <p><a parentName="p" {...{
        "href": "https://gum.co/pEmTq"
      }}>{`Serverless Workshop`}</a>{` is the best way to dive into serverless cloud functions.`}</p>
    <p>{`If you want to understand how they work, learn the mindset of how to wield them, and grok which provider is best for your use case, this is the workshop for you.`}</p>
    <p><a parentName="p" {...{
        "href": "https://gum.co/pEmTq"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "88.34080717488789%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'353\\'%20viewBox=\\'0%200%20400%20353\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M10%2011L9%20118v106h380v-26c0-20-1-26-2-27l-1%202c0%202%200%202-11%202l-11-1v-6c1-6-2-5-3%201-1%202-2%204-4%204h-3c-2%202-7-1-8-4s-1-3-5-3c-3%200-4%201-4%203%200%204-9%206-14%204-4-3-6-2-11%202l-4%203h-10c-9-1-10-1-22-7a202%20202%200%2000-18-10l-9-3h-4l1-5%203-8%202-5%205-7c8-6%209-8%2013-28V91a144%20144%200%20010-37l5-1%206-2a285%20285%200%200025-3l8-2c14-2%2055-3%2067-2%2010%201%209%202%209-18V11l-190-1-189%201m75%2033l-1%205c-1%204-2%205-3%205-1%201-2%200-2-1s-1-2-5-3c-3%200-4%200-3%201%200%202%200%202-3%201-5-1-5-1-5%206%200%206%200%207%203%208%204%201%2019%205%2020%204V45l-1-1m249%2026l-21%201%201%2075%201%208h28l30-1v-42l-1-42-9-1-29%202m52%2023c0%2018%201%2025%202%2026s1-4%201-24c0-23%200-26-2-26l-1%2024m-49%202l-5%201-1%209%201%2016v7h22V95l-6-1-11%201m2%206c-2%201-2%201-2%2010v9h3c8%200%209%200%209-9%200-10-2-12-10-10m-187%2024c-3%200-5%203-4%205v16l1%205c0%206%201%2010%205%2014l2%203%203-2%209-5c6-3%206-4%202-5-2%200-4-1-6-5-3-5-3-6%200-8%203-3%201-6-4-7-4-1-4-1-5-6%200-5-1-5-3-5m192%2010c-1%206-1%206%206%206l5%201v-5c0-6-1-7-7-7h-4v5m-19%2067h-4v6l1%206h7l9-1v-10c-1-1-9-2-13-1m-57%2050v11h104v-22H268v11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d67f5b00d06ccbdc5da973e9aec0c58f/ca0a1/CxMGGmpngee08ce.webp 223w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/75680/CxMGGmpngee08ce.webp 445w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/8d1ba/CxMGGmpngee08ce.webp 890w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/3838e/CxMGGmpngee08ce.webp 1335w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/78e5d/CxMGGmpngee08ce.webp 1452w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d67f5b00d06ccbdc5da973e9aec0c58f/e92b6/CxMGGmpngee08ce.png 223w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/e66bf/CxMGGmpngee08ce.png 445w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/4ef49/CxMGGmpngee08ce.png 890w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/4e814/CxMGGmpngee08ce.png 1335w", "/static/d67f5b00d06ccbdc5da973e9aec0c58f/add4c/CxMGGmpngee08ce.png 1452w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d67f5b00d06ccbdc5da973e9aec0c58f/4ef49/CxMGGmpngee08ce.png",
              "alt": "CxMGGmpngee08ce",
              "title": "CxMGGmpngee08ce",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Happening live October 5th at a Zoom link near you.`}</p>
    <p>{`Designed for everyone interested in serverless and cloud functions.`}</p>
    <p>{`You'll learn:`}</p>
    <ul>
      <li parentName="ul">{`when to use serverless cloud functions`}</li>
      <li parentName="ul">{`how to use cloud functions in 3 environments - Netlify - Vercel - AWS Lambda`}</li>
      <li parentName="ul">{`2 ways to read params from the browser and when to use them`}</li>
      <li parentName="ul">{`using serverless to integrate with a 3rd party API (you'll send an SMS)`}</li>
      <li parentName="ul">{`automating browser interactions with Chrome Puppeteer (you'll take a web screenshot)`}</li>
      <li parentName="ul">{`write files to S3`}</li>
      <li parentName="ul">{`how to read and write data to a database`}</li>
      <li parentName="ul">{`integrate your cloud function with a simple UI`}</li>
    </ul>
    <p>{`You'll gain a feel for what serverless cloud functions can do and how you can start using them in your projects. At work or otherwise.`}</p>
    <p>{`Doing the exercises will teach you about debugging, deploying to production, monitoring your code, logging errors, managing permissions, and dealing with secrets. All crucial tools in your quest.`}</p>
    <p><a parentName="p" {...{
        "href": "https://gum.co/pEmTq"
      }}>{`Reserve your spot today`}</a>{` and learn how your skills can do more. Enrollment closes today.`}</p>
    <h2 {...{
      "id": "what-you-get"
    }}>{`What you get`}</h2>
    <p>{`Buying `}<a parentName="p" {...{
        "href": "https://gum.co/pEmTq"
      }}>{`Serverless Workshop`}</a>{` gets you live access to the workshop, the pre videos, and lifetime access to the recording.`}</p>
    <p>{`Before the workshop, you get a few short videos with the basic theory. You can think of these as a mini course.`}</p>
    <p>{`Just watching those videos you'll learn a bunch and we can focus on exercises during the workshop without wasting time 😍`}</p>
    <p>{`After the live workshop, you get lifetime access to the exercises in a self-paced workshop format. Review when you want, play around as you please.`}</p>
    <p><a parentName="p" {...{
        "href": "https://gum.co/pEmTq"
      }}>{`Reserve your spot today`}</a>{` and become the future looking expert in your field.`}</p>
    <p>{`Cheers,
~Swizec`}</p>
    <p>{`PS: if $279 is tough right now, there's an `}<a parentName="p" {...{
        "href": "https://gum.co/wYpbg"
      }}>{`option to pay in installments`}</a>{` or you can reply to this email and we'll work something out`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      